import {
  SIMULADOR_FINANCIERO_NEW_LINEA_FINANCIERA_BEGIN,
  SIMULADOR_FINANCIERO_NEW_LINEA_FINANCIERA_SUCCESS,
  SIMULADOR_FINANCIERO_NEW_LINEA_FINANCIERA_FAILURE,
  SIMULADOR_FINANCIERO_NEW_LINEA_FINANCIERA_DISMISS_ERROR,
} from './constants';
import axios from "axios";
import { REACT_APP_API_SF } from '../../../common/config';

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function newLineaFinanciera({altaNuevaLinea = {}} = {}) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: SIMULADOR_FINANCIERO_NEW_LINEA_FINANCIERA_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      let lineasAux = [...altaNuevaLinea.asignacionLineas.lineas];
      let lineas = [];
      lineasAux.forEach((linea) => {
        lineas.push(
          {
            brandId: linea.data.idBrand,
            brand: linea.data.nameBrand,
            modelId: linea.data.idModel,
            model: linea.data.nameModel,
            versionId: linea.data.idVersion,
            version: linea.data.nameVersion,
            ventaDirecta: linea.data.ventaDirecta,
            ventaConvencional: linea.data.ventaConvencional,
            yearMMV_desde: linea.data.year_desde,
            yearMMV: linea.data.year,
            car_lot_id: linea.data.car_lot_id,
            antiguedad: linea.data.antiguedad
          }
        );
      })
      let body = {
        lineaCredito: {
          entidadOtorganteId: altaNuevaLinea.datosFinancieros.entidadOtorgante.value ? altaNuevaLinea.datosFinancieros.entidadOtorgante.value : '',
          entidadOtorgante: altaNuevaLinea.datosFinancieros.entidadOtorgante.label ? altaNuevaLinea.datosFinancieros.entidadOtorgante.label : '',
          tipoCreditoId: altaNuevaLinea.datosFinancieros.tipoCredito.value ? altaNuevaLinea.datosFinancieros.tipoCredito.value : '',
          lineaCreditoBancaria: altaNuevaLinea.datosFinancieros.lineaCreditoBancaria,
          lineaComercial: altaNuevaLinea.datosFinancieros.lineaComercial,
          tipoTasa: altaNuevaLinea.datosFinancieros.tipoTasa.value ? altaNuevaLinea.datosFinancieros.tipoTasa.value: '',
          requisitos: altaNuevaLinea.datosFinancieros.requisitos,
          fechaVigenciaIni: altaNuevaLinea.datosFinancieros.fechaVigenciaIni,
          fechaVigenciaFin: altaNuevaLinea.datosFinancieros.fechaVigenciaFin,
          promocionClienteBanco: altaNuevaLinea.datosFinancieros.promocionClienteBanco,
          beneficio: altaNuevaLinea.datosFinancieros.beneficio,
          bloqueado: altaNuevaLinea.datosFinancieros.bloqueado,
          tipoMMV: altaNuevaLinea.asignacionLineas.tipoVehiculo ? 1 : 0,
          exceedFinanceLimit: altaNuevaLinea.datosFinancieros.exceedFinanceLimit,
        },
        cuotas: altaNuevaLinea.datosFinancieros.cuotas,
        lineas: lineas
      }

      const doRequest = axios.post(REACT_APP_API_SF + "/credits", body);
      doRequest.then(
        (res) => {
          dispatch({
            type: SIMULADOR_FINANCIERO_NEW_LINEA_FINANCIERA_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: SIMULADOR_FINANCIERO_NEW_LINEA_FINANCIERA_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissNewLineaFinancieraError() {
  return {
    type: SIMULADOR_FINANCIERO_NEW_LINEA_FINANCIERA_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case SIMULADOR_FINANCIERO_NEW_LINEA_FINANCIERA_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        newLineaFinancieraPending: true,
        newLineaFinancieraError: null,
      };

    case SIMULADOR_FINANCIERO_NEW_LINEA_FINANCIERA_SUCCESS:
      // The request is success
      return {
        ...state,
        newLineaFinancieraPending: false,
        newLineaFinancieraError: null,
      };

    case SIMULADOR_FINANCIERO_NEW_LINEA_FINANCIERA_FAILURE:
      // The request is failed
      return {
        ...state,
        newLineaFinancieraPending: false,
        newLineaFinancieraError: action.data.error,
      };

    case SIMULADOR_FINANCIERO_NEW_LINEA_FINANCIERA_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        newLineaFinancieraError: null,
      };

    default:
      return state;
  }
}
